<template>
    <div class="card">
        <div class="card-header">
            <h2>Protocolos Registrados</h2>
            <span>Solicitações enviadas pelo estabelecimento para análise do serviço de inspeção</span>
        </div>

        <div class="table-wrap">
            <table class="data-table">
                <thead>
                    <tr>
                        <th>Protocolo</th>
                        <th>Estabelecimento</th>
                        <th>Tipo</th>
                        <th>Produto</th>
                        <th>Status</th>
                        <th>Data</th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="item in lsDados"
                        :key="item.id"
                        @click="$emit('selecionar', item)"
                        :class="{ selected: item.id === itemSelecionadoId }"
                    >
                        <td>{{ item.protocolo }}</td>
                        <td>{{ item.estabelecimentoNome }}</td>
                        <td>{{ formatarTipo(item.tipoSolicitacao) }}</td>
                        <td>{{ item.produtoNome }}</td>
                        <td>
                            <span class="badge" :class="badgeClass(item.status)">
                                {{ formatarStatus(item.status) }}
                            </span>
                        </td>
                        <td>{{ formatarData(item.dataSolicitacao) }}</td>
                    </tr>

                    <tr v-if="!lsDados.length">
                        <td colspan="6" class="empty">
                            Nenhum protocolo registrado.
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script setup>
defineProps({
    lsDados: { type: Array, default: () => [] },
    itemSelecionadoId: { type: Number, default: 0 }
})

defineEmits(['selecionar'])

function formatarTipo(tipo) {
    const mapa = {
        NOVO_REGISTRO: 'Novo registro',
        ALTERACAO: 'Alteração',
        CANCELAMENTO: 'Cancelamento'
    }
    return mapa[tipo] || tipo
}

function formatarStatus(status) {
    const mapa = {
        EM_ANALISE: 'Em análise',
        COM_PENDENCIA: 'Com pendência',
        APROVADO: 'Aprovado',
        REPROVADO: 'Reprovado'
    }
    return mapa[status] || status
}

function badgeClass(status) {
    if (status === 'APROVADO') return 'success'
    if (status === 'COM_PENDENCIA') return 'warning'
    if (status === 'REPROVADO') return 'danger'
    return 'info'
}

function formatarData(data) {
    if (!data) return ''
    const [ano, mes, dia] = data.split('-')
    return `${dia}/${mes}/${ano}`
}
</script>

<style scoped>
.card {
    background: #ffffff;
    border: 1px solid #dfe4ea;
    border-radius: 10px;
    padding: 18px;
}

.card-header {
    margin-bottom: 14px;
}

.card-header h2 {
    margin: 0;
    font-size: 18px;
    color: #1f2937;
}

.card-header span {
    display: block;
    margin-top: 4px;
    color: #6b7280;
    font-size: 14px;
}

.table-wrap {
    overflow-x: auto;
}

.data-table {
    width: 100%;
    border-collapse: collapse;
}

.data-table thead th {
    text-align: left;
    padding: 12px;
    background: #f3f4f6;
    color: #374151;
    font-size: 13px;
    border-bottom: 1px solid #d1d5db;
}

.data-table tbody td {
    padding: 12px;
    border-bottom: 1px solid #e5e7eb;
    font-size: 14px;
    color: #111827;
}

.data-table tbody tr {
    cursor: pointer;
    transition: 0.2s;
}

.data-table tbody tr:hover {
    background: #f9fafb;
}

.data-table tbody tr.selected {
    background: #eff6ff;
}

.empty {
    text-align: center;
    color: #6b7280;
    padding: 18px;
}

.badge {
    display: inline-block;
    padding: 5px 9px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 600;
}

.badge.success {
    background: #dcfce7;
    color: #166534;
}

.badge.warning {
    background: #fef3c7;
    color: #92400e;
}

.badge.danger {
    background: #fee2e2;
    color: #991b1b;
}

.badge.info {
    background: #dbeafe;
    color: #1d4ed8;
}
</style>